import React, {useState} from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import UserInfo from '../../Components/User/UserInfo';
import s from './RegistrationNewClient.module.css';
import ApprovePhoneForm from './ApprovePhoneForm';
import {Form, Formik, FormikHelpers, FormikValues} from 'formik';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import {useDispatch, useSelector} from 'react-redux';
import {registerUser} from '../../redux/userSlice';
import {AppDispatch, RootState} from '../../redux/store';
import {RegisterClientData, UserClient} from '../../types/TypesUser';
import FindDistributorsComponent from '../../Components/FindDistributorsComponent/FindDistributorsComponent';
import GenderSelect from './GenderSelect';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import AreasSelector from '../../Components/NewDeliverySelectors/AreasSelector';
import OrderCitySelect from '../../Components/InputSelect/OrderCitySelect';
import CustomSelect, {BaseOption} from '../../Components/Select/CustomSelect';
import {CalendarField} from './components';
import {CustomInput} from '../../Components/Input';
import SelectSvgSelector from '../../Components/InputSelect/SelectSvgSelector';
import {monthNow} from '../../assets/utils/dateUtils';
import {useGetClientsRegListQuery} from '../../redux/userClientsApi';
import TableRegistrationList from './TableRegistrationList';
import {LoadingIndicator} from 'react-select/dist/declarations/src/components/indicators';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';
import AddFilterButton from '../../Components/Buttons/AddFilterButton';
import RegistrationListFilter from './components/RegistrationListFilter';

const RegistrationNewClient = ({type}: {type: 'client' | 'manager'}) => {
	const dispatch: AppDispatch = useDispatch();
	const {t} = useTranslation();
	const refCode = useSelector(
		(state: RootState) => state.appData.session.refcode,
	);
	const [newbieType, setNewbieType] = useState<'client' | 'manager'>(type);
	const [phone, setPhone] = useState('');
	const [errorPhone, setErrorPhone] = useState('');
	const [client, setClient] = useState<UserClient | null>(null);
	const apiData = useSelector((state: RootState) => state.appData.appData);
	const [selectedMonth, setSelectedMonth] = useState<string>(monthNow());
	const [filterMenu, setFilterMenu] = useState(false);
	const {data, isLoading, isFetching} = useGetClientsRegListQuery(selectedMonth);
	const initialValues = {
		phone: phone,
		surname: '',
		name: '',
		middlename: '',
		birth_date: '',
		contract: '',
		refcode: refCode,
		mail_state: t('Україна'),
		mail_region: '',
		mail_area: '',
		mail_city: '',
		email: '',
		gender: '',
		sponsor_id: client?.client_id,
		foundedUserName: '',
		type: newbieType,
	};

	const handleChangeType = (option: BaseOption | null) => {
		if (option) {
			const value = option.value as 'manager' | 'client';
			setNewbieType(value);
		}
	};
	type InitialValues = typeof initialValues;
	const handleSubmit = async (
		values: InitialValues,
		formikHelpers: FormikHelpers<InitialValues>,
	) => {
		const registerData: RegisterClientData = {
			birth_date: values.birth_date,
			name: values.name,
			email: values.email,
			phone: phone,
			surname: values.surname,
			gender: values.gender,
			address: values.mail_area,
			country: values.mail_state,
			city: values.mail_city,
			region: values.mail_region,
			sponsor_id: client?.client_id ? +client.client_id : 0,
			type: newbieType,
			middlename: values.middlename,
		};
		dispatch(
			registerUser({
				registerData,
				resetForm: formikHelpers.resetForm,
				setStatus: formikHelpers.setStatus,
			}),
		);
	};

	const typeName = newbieType === 'client' ? t('клієнта') : t('партнера');

	const typeOptions: BaseOption[] = [
		{value: 'client', label: t('Клієнт')},
		{value: 'manager', label: t('Партнер')},
	];
	return (
		<div className="page__content">
			<TopTitleBlock title={newbieType === 'client' ? t('реєстрація клієнта') : t('реєстрація партнера')} />
			<div className="page__user-profile user-profile">
				<div className="user__column">
					<UserInfo />
				</div>
			</div>
			<div className={s.formBlocksContainer}>
				<div className={s.approvePhoneContainer}>
					<div className="page__user-profile user-profile">
						<ApprovePhoneForm
							setPhone={setPhone}
							phone={phone}
							error={errorPhone}
						/>
					</div>
				</div>
				<Formik
					enableReinitialize
					initialValues={initialValues}
					onSubmit={handleSubmit}
				>
					{({handleSubmit, status}) => {
						status && status.phone
							? setErrorPhone(status.phone)
							: setErrorPhone('');
						return (
							<Form onSubmit={handleSubmit}>
								<div
									className={`${s.clientInfoContainer} "page__user-profile user-profile"`}
								>
									<div className={s.inputName}>{apiData.text_clientInfo}</div>
									<div>
										<FindDistributorsComponent
											client={client}
											setClient={setClient}
											status={status}
											componentType={'registered'}
										/>
									</div>
								</div>
								<div className={s.clientTypeContainer}>
									<div className={s.inputName}>{t('Тип новачка')}</div>
									<CustomSelect
										options={typeOptions}
										value={typeOptions.find((opt) => opt.value === newbieType)}
										onChange={handleChangeType}
										size="md"
									/>
								</div>
								<div className={s.mainInfoContainer}>
									<div className={s.inputName}>{apiData.text_mainInfo}</div>
									<div className={s.inputsMainBlock}>
										<div className={s.content_Column}>
											<CustomInput
												name="surname"
												placeholder={apiData.text_surnamePlaceholder}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
											<CustomInput
												name="name"
												placeholder={apiData.text_namePlaceholder}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
											<CustomInput
												name="middlename"
												placeholder={apiData.text_fatherNamePlaceholder}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
										</div>
										<div className={s.content_Column}>
											<GenderSelect />
											<CalendarField
												name="birth_date"
												placeholder={apiData.text_birthdayPlaceholder}
											/>
											<CustomInput
												name="email"
												placeholder={apiData.text_emailPlaceholder}
												type="email"
												icon={<SelectSvgSelector id={'email'} />}
											/>
										</div>
									</div>
								</div>
								<div className={s.mainInfoContainer}>
									<div className={s.inputName}>{apiData.text_address}</div>
									<div className={s.inputsMainBlock}>
										<div className={s.content_Column}>
											<CustomInput
												name="mail_state"
												placeholder={t('Країна')}
											/>
											<AreasSelector fieldName={'mail_region'} />
										</div>
										<div className={s.content_Column}>
											<OrderCitySelect token={''} fieldName={'mail_city'} />
											<CustomInput
												name="mail_area"
												placeholder={apiData.text_addressPlaceholder}
											/>
										</div>
									</div>
								</div>
								<div className={s.privacyContainerWrapper}>
									<div className={s.privacyContainer}>
										<span>
											{t(
												'«Натискаючи «Зареєструвати», Ви підтверджуєте, що ознайомлені з положеннями та умовами»',
											)}{' '}
										</span>
										<Link
											to={`${process.env.REACT_APP_DOMEIN_URL}statut-choice.pdf`}
										>
											{t('Статуту компанії')}
										</Link>
									</div>
								</div>
								<div className={s.submitButton}>
									<LightGreenButton
										type={'submit'}
										text={newbieType === 'client' ? t('зареєструвати клієнта') : t('зареєструвати партнера')}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
				<div className={s.listRegisteredTitle}>
					{apiData.text_registeredList}
				</div>
				<AddFilterButton
					filterMenu={filterMenu}
					setFilterMenu={setFilterMenu}
					color={'green'}
				/>
				<RegistrationListFilter
					active={filterMenu}
					setActive={setFilterMenu}
					setMonth={setSelectedMonth}
					currentMonth={selectedMonth}
				/>
				{isLoading ? (
					<Loader />
				) : (
					data?.users && <TableRegistrationList data={data.users} />
				)}
			</div>
		</div>
	);
};

export default RegistrationNewClient;
